// Enum pour les actions standards
export enum Action {
  READ = "read",
  CREATE = "create",
  UPDATE = "update",
  DELETE = "delete",
}

// Enum pour les ressources
export enum Resource {
  REGISTRATION = "inscription",
  PARENT = "parents",
  TEACHER = "teachers",
  CLASS = "classes",
  SUBJECT = "subjects",
  SUBJECT_UE = "subjectUE",
  CLASSROOM = "classrooms",
  LEVEL = "levels",
  LINK_TYPEs = "linkTypes",
  STUDENT_PARENT = "studentParent",
  NOTE = "notes",
  EXTERNAL_NOTE = "externalNotes",
  // NOTE_HISTORY = "noteHistory",
  EVALUATION = "evaluations",
  USER = "users",
  ACADEMIC_YEAR = "academicYears",
  EVAL_PERIOD = "evaluationPeriods",
  EXPORT = "exports",
  STUDENT = "students",
  SEARCH = "search",
  FUNCTIONALITY = "functionality",
  UE = "ues",
  DEPARTMENT = "departements",
  RELEVE = "releve",
  DIPLOME = "diplome",
  ATTESTATION = "attestation",
  PDF = "pdf",
  PERMISSIONS = "permissions",
  CALCULATION_METHODS = "calculationMethods",
  ARCHIVE = "archives",
  DOCUMENTATION = "documentation",
  EMARGEMENT = "emargement",
  FREQUENTATION = "frequentation",

  // Phase 2  --------------------------------------
  STUDENT_ABSENCE = "absenceStudent",
  STUDENT_SANCTION = "sanction",
  STUDENT_LATE = "late",
  TEACHER_ABSENCE = "absenceTeacher",
  // BREAKTIME = "breakTime",
  COURSE = "course",
  HOMEWORK = "homework",
  // HOMEWORK_ANSWER = "homeworkAnswer",
  COURSE_TRACKING = "courseTracking",
  // WORKINGDAY = "workingDay",
  EDT = "EDT",
  EDTE = "coursEDTE",
  SETTING_EDT = "settingEDT",
  // SEANCES = "sessions",
  HOURLYRATE_TEACHER = "hourlyRate",
  TEACHER_REPORT = "teacherReport",
  FILE_ATTACHEMENT = "fileAttachement",
  MESSAGE = "message",
  COURSE_SUPPORT = "courseSupport",
  CLASSEMENT = "classement",

  // PHASE 3 & 4-----------------
  BOURSE_REMISE = "discount",
  // BANK_ACCOUNT = "bankAccount",
  PAYMENT_PLAN = "paymentPlans",
  STUDENT_PAYMENT_PLAN = "studentPaymentPlan",
  PAYMENT = "studentPayment",
  PAYMENT_SETTING = "paymentSetting",
  NOTE_SETTING = "noteSetting",
  NOTE_RESTRICTION = "noteRestriction",
  REQUEST = "request",
  VISITOR = "visitor",
  FILIERE = "filiere",
  CLAIM = "claim",
  MEMOIRE = "memory",
  EVENT = "event",
  DIPLOME_AUTH = "diplomeAuth",
  PARCOURS = "parcours",
  // DASHBOARD = "",
}

// Helper pour construire la permission string
export function buildPermission(resource: Resource, action: Action) {
  return `${resource}:${action}`;
}
// Helper pour construire le contexte permission string
export function buildPermissionContext(resource: Resource, action: Action) {
  return `${resource}.${action}`;
}
